export const formattedNumber = (value: string) => {
  const valueInt = Number(value);
  return new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
  }).format(valueInt);
};
